import React, { useEffect, useState } from "react";
import { env } from "../../env_config";
import { ResetPage } from "../ResetPage";
import { VerifyEmail, VerifyPage, VerifyPassword } from "../VerifyPage";
import { GetQueryString } from "../../Utils";
import { fetchVerifyEmail, fetchVerifyToken } from "../../Utils/api";
import { en, zh } from "../../Utils/i10";

export const Home = () => {
    const [tokenVerify, setTokenVerify] = useState(undefined);
    const [verifyMes, setVerifyMes] = useState("");
    let mode = GetQueryString("mode").toLocaleLowerCase();
    useEffect(() => {
      _tokenVerify();
    }, []);
  
    const translateI10 = () => {
      const lan = GetQueryString("lang").toLocaleLowerCase();
      const lanType = lan.includes("en") ? true : false;
      return lanType ? en() : zh();
    };
  
    const _tokenVerify = async () => {
      const key = GetQueryString("oobCode");
      const apikey = GetQueryString("apiKey");
      try {
        let res = {};
        if (mode.includes("mail")) {
          res = await fetchVerifyEmail(key, apikey);
        } else {
          res = await fetchVerifyToken(key, apikey);
        }
        const { code, message } = res.error || {};
        if (code) {
          // error-type
          setTokenVerify(false);
          setVerifyMes(translateI10()[message] || translateI10().link_has_exp);
        } else {
          // success-type
          setTokenVerify(true);
          setVerifyMes(translateI10().email_success);
        }
      } catch (error) {
        console.log("0714-err-1=", error);
        setTokenVerify(false);
        setVerifyMes(translateI10().network_err);
      }
    };
    return (
      <div>
        {tokenVerify === undefined ? (
          <div></div>
        ) : !tokenVerify ? (
          mode.includes("mail") ? (
            <VerifyEmail
              verifyRes={tokenVerify}
              trans={translateI10()}
              verifyMes={verifyMes}
            />
          ) : (
            <VerifyPassword
              verifyRes={tokenVerify}
              trans={translateI10()}
              verifyMes={verifyMes}
            />
          )
        ) : mode.includes("mail") ? (
          <VerifyEmail
            trans={translateI10()}
            verifyRes={tokenVerify}
            verifyMes={verifyMes}
          />
        ) : (
          <ResetPage trans={translateI10()} />
        )}
      </div>
    );
  };